import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import styles from './assets/substitution-create-screen.module.scss';
import RoleLayout from 'src/components/layout/RoleLayout';
import Form from '../../components/SubstitutionForm';
import { Paginated } from '../../../../../../services/api-handlers/pagination';
import { ISeance } from '../../../../../../types/seance';
import { QueryParams } from '../../../../../../types/grid';

import { toast } from 'react-toastify';
import { changeToZeroMoment } from '../../../../../../helpers/timeHelpers';

export interface StateProps {
    inProgress: boolean;
    inProgressSeance: boolean;
    inProgressProvider?: boolean;
    data: Paginated<ISeance>;
    valuesForm: any;
    providers: SelectObject[];
}

export interface DispatchProps {
    getData: (params: QueryParams) => void;
    getProviders: (params: QueryParams) => void;
}

export interface OwnProps {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const SubstitutionCreateScreen: React.FunctionComponent<Props> = (props) => {
    //const [files, setFiles] = useState([]);
    const [stateData, setStateData] = useState<any>({});
    const [isFirst, setIsFirst] = useState<any>(false);

    let provider: any = '';
    let seanceDateFrom: any = '';
    let seanceDateTo: any = '';
    let substitutedProviderDropDown: any = '';
    if (props.valuesForm) {
        provider = props.valuesForm.providerDropDown;
        seanceDateFrom = props.valuesForm.seanceDateFrom;
        seanceDateTo = props.valuesForm.seanceDateTo;
        substitutedProviderDropDown = props.valuesForm.substitutedProviderDropDown;
    }
    const findSeance = () => {
        const filters: any = {};

        if (provider) {
            filters['provider.id'] = provider.value;
        }
        if (seanceDateFrom) {
            filters['seanceDate[after]'] = changeToZeroMoment(seanceDateFrom, 'YYYY-M-D');
        }
        if (seanceDateTo) {
            filters['seanceDate[before]'] = changeToZeroMoment(seanceDateTo, 'YYYY-M-D');
        }
        if (provider || (seanceDateFrom && seanceDateTo)) {
            props.getData({
                page: 1,
                filters: filters,
                itemsPerPage: 1200,
            });
        }
        if ((provider && substitutedProviderDropDown) || (seanceDateFrom && seanceDateTo)) {
            setIsFirst(true);
        }
    };

    useEffect(() => {
        props.getProviders({
            page: 1,
            itemsPerPage: 1200,
        });
        // eslint-disable-next-line
    }, [props.getProviders]);

    const handleSub = (handleSubmit: (e: any) => void, e: any) => {
        if (Object.keys(stateData).length) {
            handleSubmit(e);
        } else {
            toast.error('No Sessions');
            return false;
        }
    };
    return (
        <RoleLayout>
            <div>
                <h2>SUBSTITUTIONS {`>`} ADD NEW SUBSTITUTION</h2>
            </div>
            <div className={classNames(styles.wrapForm)}>
                <Form
                    provider={props.valuesForm?.providerDropDown}
                    data={props.data}
                    isFirst={isFirst}
                    stateData={stateData}
                    setStateData={setStateData}
                    handleSub={handleSub}
                    inProgressSeance={props.inProgressSeance}
                    providers={props.providers}
                    findSeance={() => findSeance()}
                    initialValues={{}}
                />
            </div>
        </RoleLayout>
    );
};

export default SubstitutionCreateScreen;
